import state from './moduleTicketTransferState'
import actions from './moduleTicketTransferActions'
import getters from './moduleTicketTransferGetters'
import mutations from './moduleTicketTransferMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}
